export default __webpack_public_path__ + "static/media/unipan-catalogue.d00c4834.pdf";